<div
  *ngFor="let step of steps; let i = index"
  class="step"
  [ngClass]="'theme-' + themeColor"
  [class.current]="currentStepIndex === i"
  [class.done]="
    currentStepIndex > i || (currentStepIndex === i && step.isDoneStep)
  "
>
  <header>
    <div class="step-icon">
      <i [inlineSVG]="getIcon(step)"></i>
    </div>
    <label>{{ step.isDoneStep ? "" : "STEP " + (step.stepIndex + 1) }}</label>
    <span>{{ step.isDoneStep ? "DONE!" : step.name }}</span>
  </header>
  <div class="step-body">
    <div>
      <label>{{ step.description }}</label
      ><br />
    </div>
  </div>
</div>
